import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "tw-flex" }
const _hoisted_2 = ["data-editable", "data-loading"]
const _hoisted_3 = ["data"]
const _hoisted_4 = ["textContent"]
const _hoisted_5 = {
  key: 0,
  class: "tw-absolute tw-card",
  style: {"width":"166px","left":"-36px","background-color":"white","padding":"6px"}
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-save tw-mr-1" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times-circle" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_shared_btn = _resolveComponent("shared-btn")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives((_openBlock(), _createElementBlock("div", {
      "data-editable": _ctx.editable,
      class: _normalizeClass(["tw-relative tw-h-full", _ctx.editable ? 'xl:tw-mx-4' : null]),
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.edit = true)),
      style: _normalizeStyle(_ctx.editable ? { height: '106px', width: '106px' } : null),
      "data-loading": _ctx.loading
    }, [
      _createElementVNode("object", {
        data: _ctx.src,
        type: "image/png",
        class: _normalizeClass(`${_ctx.size === 8 ? 'tw-w-8' : _ctx.size === 16 ? 'tw-w-16' : 'tw-w-24'} ${
          _ctx.size === 8 ? 'tw-h-8' : _ctx.size === 16 ? 'tw-h-16' : 'tw-h-24'
        } tw-object-cover tw-rounded-full`),
        id: "avatar"
      }, [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-w-full tw-h-full tw-rounded-full tw-bg-gray-300 tw-flex tw-justify-center tw-items-center ${_ctx.fontSize} tw-font-bold tw-text-white tw-tracking-wide`),
          textContent: _toDisplayString(_ctx.initials)
        }, null, 10, _hoisted_4)
      ], 10, _hoisted_3),
      (_ctx.edit && _ctx.editable)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createVNode(_component_shared_btn, {
              shape: "text",
              onClick: _cache[0] || (_cache[0] = _withModifiers(() => _ctx.$refs.picker.click(), ["stop"])),
              class: "tw-text-success hover:bg-gray-100"
            }, {
              default: _withCtx(() => [
                _hoisted_6,
                _createTextVNode("Carica file ")
              ]),
              _: 1
            }),
            _createVNode(_component_shared_btn, {
              shape: "text",
              onClick: _withModifiers(_ctx.remove, ["stop"]),
              class: "text-error hover:tw-bg-gray-100 tw-w-full"
            }, {
              default: _withCtx(() => [
                _hoisted_7,
                _createTextVNode(" Elimina ")
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("input", {
        type: "file",
        class: "tw-hidden",
        ref: "picker",
        onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.upload && _ctx.upload(...args)))
      }, null, 544)
    ], 14, _hoisted_2)), [
      [_directive_click_outside, () => (_ctx.edit = false)]
    ])
  ]))
}